export default __webpack_public_path__ + "static/stamp-581d9170b12f995dfee11001d85a6967.svg";